// @flow
import * as React from "react";
import styled from "styled-components";
import tw from "tailwind-styled-components";

const Checkbox: React.ComponentType<{}> = tw.input`
  form-checkbox
  rounded
  border
  h-5
  w-5
  text-blue-600
`;

const StyledCheckbox: React.ComponentType<{}> = styled(Checkbox).attrs({
  type: "checkbox",
})``;

export default StyledCheckbox;
